import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DivButton from '../DivButton/DivButton.jsx'
import rootActions from 'actions/rootActions'
import InputGroupText from '../inputGroupText/InputGroupText.jsx'

class AddPresetDialog extends React.Component {
  constructor() {
    super()

    this.state = {
      name: ''
    }
  }
  presetName = () => {
    const name = this.state.name
    const highlight =
      name === undefined || name === ''
        ? { borderColor: 'red' }
        : {}
    return (
      <InputGroupText
        aria-label={'preset name'}
        title="Preset Name"
        value={name}
        stretch={true}
        placeholder=""
        style={{ ...highlight, textAlign: 'right' }}
        onChange={e => {
          this.setState({ name: e.target.value })
        }}
      />
    )
  }
  render() {
    return (
      <div className="standard-modal-content">
        <div className="message-content">
          <div style={{ marginBottom: '15px', width: '30%' }}>
            <br />
            {this.presetName()}
            <br />
            <br />
          </div>
        </div>
        <div className={'standard-modal-button-container'}>
          <DivButton
            className={'btn btn-danger'}
            aria-label={`modal cancel button`}
            onClick={this.props.closeSelf}
          >
            Cancel
          </DivButton>
          <DivButton
            className={'btn btn-success'}
            aria-label={`modal download button`}
            onClick={() => {
              this.props.okHandler(this.state.name)
              this.props.closeSelf()
            }}
          >
            Save
          </DivButton>
        </div>
      </div>
    )
  }
}

AddPresetDialog.propTypes = {
  // callback function for okButton
  okHandler: PropTypes.func,
  // callback function for cancel button
  cancelHandler: PropTypes.func,
  count: PropTypes.number,
  totalRows: PropTypes.number,
  pageSize: PropTypes.number,
  maxPageSize: PropTypes.number
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(rootActions, dispatch)
}

export default connect(null, mapDispatchToProps)(AddPresetDialog)
